import { useStaticQuery, graphql } from "gatsby"

export const useSectionDemoStepsData = () => {
  const data = useStaticQuery(graphql`
    query demoStepsQuery {
      contentfulSectionDemoSteps {
        title
        items {
          title
          shortDescription {
            shortDescription
          }
          content {
            url
          }
          contentPoster {
            url
          }
        }
      }
    }
  `)
  return data.contentfulSectionDemoSteps
}
